import React from 'react';
import { Redirect } from 'react-router';
import { findLastIndex } from 'lodash';

const transformRegistrationStatus = (data, route, history) => {
  const { setupProgress } = data.schoolOrDistrictRegistration;
  const {
    haveStaffBeenEmailed: isStaffSetupCompleted,
    orgsEmailed,
    parentsEmailed,
    siteLinked,
    status,
  } = setupProgress;

  const isSchoolSetupCompleted =
    siteLinked === 'visited' || siteLinked === 'confirmed';
  const isOrgsSetupCompleted =
    orgsEmailed === 'visited' || orgsEmailed === 'confirmed';
  const isParentsSetupCompleted =
    parentsEmailed === 'visited' || parentsEmailed === 'confirmed';
  const isSetupCompleted = status === 'confirmed';

  const redirectTo = (isLocked, url) => {
    if (!isLocked) history.push(url);
  };

  const steps = [
    {
      id: 1,
      label: 'Payment',
      isActive: false,
      isCompleted: true,
      isLocked: false,
      onClickHandler: () => redirectTo(false, '/onboarding/payment'),
    },
    {
      id: 2,
      label: 'School Setup',
      isActive: route === '/school',
      isCompleted: isSchoolSetupCompleted,
      isLocked: false,
      onClickHandler: () => redirectTo(false, '/onboarding/setup/school'),
    },
    {
      id: 3,
      label: 'Staff Setup',
      isActive: route === '/staff',
      isCompleted: isStaffSetupCompleted,
      isLocked: !isSchoolSetupCompleted,
      onClickHandler: () =>
        redirectTo(!isSchoolSetupCompleted, '/onboarding/setup/staff'),
    },
    {
      id: 4,
      label: 'Organization Setup',
      isActive: route === '/organization',
      isCompleted: isOrgsSetupCompleted,
      isLocked: !isStaffSetupCompleted,
      onClickHandler: () =>
        redirectTo(!isStaffSetupCompleted, '/onboarding/setup/organization'),
    },
    {
      id: 5,
      label: 'Parent Setup',
      isActive: route === '/parent',
      isCompleted: isParentsSetupCompleted,
      isLocked: !isOrgsSetupCompleted,
      onClickHandler: () =>
        redirectTo(!isOrgsSetupCompleted, '/onboarding/setup/parent'),
    },
    {
      id: 5,
      label: 'Confirm Setup',
      isActive: route === '/confirm',
      isCompleted: parentsEmailed === 'confirmed',
      isLocked: !isParentsSetupCompleted,
      onClickHandler: () =>
        redirectTo(!isParentsSetupCompleted, '/onboarding/setup/confirm'),
    },
  ];

  const lastCompletedStepIndex = findLastIndex(steps, 'isCompleted');

  if (lastCompletedStepIndex < steps.length - 1) {
    steps[lastCompletedStepIndex + 1].isReady = true;
  }

  return steps;
};

export { transformRegistrationStatus };



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/containers/StepsGenerator.js